import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = "/index.php";

export default {
    namespaced: true,

    state: {
        tableColumns: [
            {
                id: "name",
                label: "ФИО",
                fullName: "ФИО",
                type: "string",
                width: "32.5%",
                level: 0,
                characteristic: ""
            },
            {
                id: "phone",
                label: "Телефон",
                fullName: "Телефон",
                type: "string",
                width: "16.5%",
                level: 0,
                characteristic: ""
            },
            {
                id: "email",
                label: "Email",
                fullName: "Email",
                type: "string",
                width: "22%",
                level: 0,
                characteristic: ""
            },
            {
                id: "created",
                label: "Создан",
                fullName: "Создан",
                width: "8%",
                type: "date",
                level: 0,
                characteristic: ""
            },
            {
                id: "orders_count",
                label: "Кол-во сделанных заказов",
                fullName: "Количество сделанных заказов",
                width: "14.5%",
                type: "number",
                level: 0,
                characteristic: ""
            },
        ],

        tableRecords: [],
    },

    mutations: {
        setTableRecords(state, records) {
            state.tableRecords = records;
        },
    },

    getters: {
        getTableColumns(state) {
            return state.tableColumns;
        },

        getTableRecords(state) {
            return state.tableRecords;
        }
    },

    actions: {
        async getIikoCustomersList(ctx, params) {
            const token = ctx.rootState.authToken;
            const {page} = params;
            const {sortBy} = params;
            const {sortType} = params;
            const customerType = (params.customerType !== undefined) ? params.customerType : "";
            const search = (params.search !== undefined) ? params.search : "";

            const baseUrl = window.location.origin;
            const queryUrl = new URL(addAuthKey(`${baseUrl}${api_url}/?r=api/iiko/customers/list&page=${page}&sort_by=${sortBy}&sort_type=${sortType}`, token));

            if (customerType.length > 0) queryUrl.searchParams.append("customer_type", customerType);
            if (search.length > 0) queryUrl.searchParams.append("search", search);

            const res = await fetch(queryUrl.toString());

            const json = await res.json();

            ctx.commit("setTableRecords", json.response);

            return json;
        },

        async changeCustomerType(ctx, params) {
            const token = ctx.rootState.authToken;
            const {customerId} = params;
            const {customerType} = params;

            const res = await fetch(addAuthKey(`${api_url}/?r=api/iiko/customers/change-customer-type&customer_id=${customerId}&customer_type=${customerType}`, token));

            const json = await res.json();

            return json;
        }
    }
};